export default "__VITE_ASSET__DZkjecCT__"